<template>
  <section>
    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center">
      <div>
        <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center" :class="{'mb-2':item.product.productPrice.isDiscounted}">
          <div class="mr-3 price-container">
            <div class="price-container__items">
              <PriceDisplay
                :product="item.product"
                :showEditPrice="userCanEditPrice(isWholesale)"
                :itemIndex="itemIndex" 
                :cartItem="item"
                @onUpdate="update" />
            </div>
          </div>
        </div>

        <Quantity
          :item="item"
          @quantityChanged="quantityChanged"
          @deleteItem="deleteItem"
          @increment="increaseQuantity"
          @decrement="decreaseQuantity"
        />

        <p v-if="item.product.ship_flat_cost && isWholesale" class="mb-0 mt-1 text-secondary text-size-small">+${{formatCurrency(item.product.ship_flat_cost * item.qty)}} Item Flat Shipping</p>
        <p v-if="item.ship_flat_cost && !isWholesale" class="mb-0 mt-1 text-secondary text-size-small">+${{formatCurrency(item.ship_flat_cost * item.qty)}} Item Flat Shipping</p>

        <h5 class="mb-0 mt-3 font-weight-bold" :class="{'on-sale text-danger': item.product.productPrice.isDiscounted}">${{formatCurrency(item.product.productPrice.price * this.item.qty)}}</h5>
      </div>
      
      <p v-if="!isCheckout" @click="deleteItem(item)" class="mb-0 text-danger text-size-small font-weight-bold cursor-pointer mt-2 mt-lg-0 d-flex align-items-center"> Remove Item <i class="fas fa-backspace ml-1"></i></p>
    </div>
  </section>
</template>

<script>
  import Quantity from '@/Shared/Quantity'
  import SetUserPrice from '@/Components/Shop/SetUserPrice'
  import PriceDisplay from '@/Components/Shop/PriceDisplay'

  export default {
    data() {
      return {
        formObject: this.$inertia.form({
          item_id: null,
          qty: null
        }),
        formDeleteItem: this.$inertia.form({
          item_id: null
        }),
      }
    },
    components: {
      Quantity,
      SetUserPrice,
      PriceDisplay,
    },
    props: {
      item: Object,
      itemIndex: Number,
      updateItemRoute: String,
      deleteItemRoute: String,
      setItemDiscountRoute: String,
      clearItemDiscountRoute: String,
      isCheckout: {
      type: Boolean,
      default: false
    },
    },
    computed: {
      getUpdateItemRoute() {
        if (this.updateItemRoute) return this.updateItemRoute;
        return this.route(this.isWholesale ? 'mtd.cart.updateItem' : 'cart.updateItem')
      },
      getDeleteItemRoute() {
        if (this.deleteItemRoute) return this.deleteItemRoute;
        return this.route(this.isWholesale ? 'mtd.cart.deleteItem' : 'cart.deleteItem');
      },
    },
    methods: {
      saveItem(item) {
        this.formObject.item_id = item.id
        this.formObject.qty = item.qty

        this.formObject.post(this.getUpdateItemRoute, {
          preserveScroll: true,
          onSuccess: () => {
            this.update();
            this.trackCartQuantityUpdate({
              id: item.product.id,
              name: item.product.name,
              price: item.price,
            }, item.linked_qty, item.qty, this.$page.props);
          },
        })
      },
      deleteItem(item) {
        if (this.formDeleteItem.processing) return;
        this.formDeleteItem.item_id = item.id
        this.formDeleteItem.post(this.getDeleteItemRoute, {
          preserveScroll: true,
          onSuccess: () => {
            this.update();
            this.trackRemoveFromCart({
              id: item.product.id,
              name: item.product.name,
              price: item.product.productPrice.price,
            }, item.qty, this.$page.props);
          },
        })
      },
      quantityChanged($event, item) {
        item.qty = $event.target.value
        this.saveItem(item)
      },
      increaseQuantity(item) {
        item.qty++
        this.saveItem(item)
      },
      decreaseQuantity(item) {
        item.qty--
        this.saveItem(item)
      },
      update() {
        this.$emit('onUpdate')
      },
    }
  }
</script>